import React, {Component} from 'react';
import '../../Compact.css';
import {ICON, NAME, TAGLINE, StoreBadges} from '../links';

let _this;

class NextTrainBostonCompact extends Component {

    constructor(props, context) {
        super(props);
        _this = this;
    }

    render() {
        return <div className="product-card">
            <div className="product-card-content">
                <div className="product-info">
                    <div>
                        <img style={{borderRadius: '10%', margin: '0 16px 0 16px'}}
                             className="roundrect"
                             src={ICON}
                             align="left"
                             alt="app icon"
                             width="128"/>
                        <div>
                            <h2>{NAME}</h2>
                            <h3>{TAGLINE}. Set your commute and the widget shows the next train to work in the
                                morning and home in the evening.</h3>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <div style={{margin: '0 24px 0 24px'}}>
                        <h4>WORKS ON IPHONE, APPLE WATCH AND ANDROID (COMING SOON)</h4>
                    </div>
                    <div className="divider"></div>
                    <div className="product-links" style={{margin: '16px 0 0 16px'}}>
                        <StoreBadges/>
                    </div>
                    <div className="divider"></div>
                    <div className="product-footer">
                        <div/>
                        <a href="#next-train-boston-product"
                           role="button"
                           className="learn-more-button"
                           onClick={() => _this.props.navigate('NextTrainBostonProduct')}
                        >Learn More →</a>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default NextTrainBostonCompact;
